// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__35Ojw","col":"styles_col__hWm4f"};